import React, { memo } from 'react';
import { BetStatus } from '../../core/constants/betStatus';
import { TranslationKeys } from '../../core/constants/translationKeys';

function TicketItem({
  t,
  odd,
  status,
  numbers,
  betAmount,
  winAmount,
  possibleWin,
  ticketNumber,
  currencyCode,
  isBetsClosed,
  isShowBetInfo,
  winNumbersForTickets,
  handleDeleteTicket,
}) {
  return (
    <div
      className={`betslip-tickets-item ${
        status === BetStatus.Win && isShowBetInfo ? 'active' : ''
      }`}
      key={ticketNumber}
    >
      <div className='betslip-tickets-item-content'>
        <div className='betslip-tickets-id-row'>
          <div className='betslip-tickets-id-txt'>
            {t(TranslationKeys.TicketId)}
            <span className='betslip-tickets-number'> {ticketNumber}</span>
          </div>
          {!isBetsClosed && status === BetStatus.Pending && (
            <div
              className='betslip-tickets-close-btn'
              onClick={() => handleDeleteTicket(ticketNumber)}
            >
              <span className='icon-close' />
            </div>
          )}
        </div>
        <div className='betslip-tickets-number-row'>
          {numbers.map((number) => {
            return (
              <div className='betslip-ticets-number-item' key={number}>
                <div
                  className={`ball-block ${winNumbersForTickets.includes(number) ? 'active' : ''}`}
                >
                  <div className='ball-inner'>{number}</div>
                </div>
              </div>
            );
          })}
        </div>
        {isShowBetInfo && (
          <div className='betslip-tickets-result-row'>
            <div className='betslip-tickets-result-bet'>
              <span className='betslip-tickets-bet-label'>{t(TranslationKeys.Bet)} : </span>
              <span className='betslip-tickets-bet-number'>
                {betAmount} {currencyCode}
              </span>
            </div>
            {status !== BetStatus.Pending ? (
              <div className='betslip-tickets-result-win'>
                <span className='betslip-tickets-bet-label'>{t(TranslationKeys.Odd)} : </span>
                <span className='betslip-tickets-win-number'>x{odd}</span>
              </div>
            ) : (
              ''
            )}
            <div className='betslip-tickets-result-win'>
              <span className='betslip-tickets-bet-label'>
                {status === BetStatus.Pending
                  ? t(TranslationKeys.PossibleWin)
                  : t(TranslationKeys.Win)}
                :
              </span>
              <span className='betslip-tickets-win-number'>
                {status === BetStatus.Pending ? possibleWin : winAmount} {currencyCode}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default memo(TicketItem);
